module.exports = __webpack_public_path__ + "static/media/app.ad48cd2b.css";


//////////////////
// WEBPACK FOOTER
// ./src/app.css
// module id = 69
// module chunks = 0